import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BallotListService } from 'src/app/ballot-list/ballot-list.service';
import { Ballot, Statement } from 'src/app/ballot/backend-types';
import { HeaderModule } from 'src/app/header/header.module';
import { dashboardRoute, pollDecisionRoute, pollResultsRoute } from 'src/app/route-names';


@Component({
    selector: 'app-poll-results-list',
    imports: [HeaderModule, MatIconModule],
    templateUrl: './poll-results-list.component.html',
    styleUrl: './poll-results-list.component.scss'
})
export class PollResultsListComponent {
  errorText: string = "";
  errorTitle: string = "";
  eventId: number = 0;
  eventIndex: number = -1;
  poll: Ballot | undefined;
  contestList: Statement[];

  constructor (
    private readonly router: Router,
    private readonly ballotListService: BallotListService,
  ) {
    this.eventId = history.state.eventId;
    this.poll = this.ballotListService.getBallots().find((p) => p.eventId === this.eventId);
    this.contestList = this.poll?.voteEventData.questions[0].statements ?? [];
  }

  selectContest(index: number) {
    this.router.navigate(pollResultsRoute, {state: {eventId: this.eventId, contestId: this.contestList?.at(index)?.statementId}})
  }

  backToDashboard() {
    this.router.navigate(dashboardRoute);
  }

  goToPoll() {
    this.router.navigate(pollDecisionRoute, {state: {eventId: this.eventId}})
  }

}
